import * as React from "react";
import { Box,  Typography } from "@mui/material";
import { Colours } from "../assets/global/Theme-variable";
import { Close } from "@mui/icons-material";
import { checkPermissions } from "../views/AccessControl";
import { useUserState } from "../context/UserContext";

export const Barcode = ({
	removeItem,
	barcode,
}) => {
	const userPermission = useUserState()
	return (
		<Box
			sx={{
				listStyle: "none",
				padding: 0,
				display: "flex",
				flexDirection: "row",
				width: "100%",
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					width: "100%",
					flexDirection: "row",
					alignItems: "center",
					backgroundColor: Colours.fieldBackground,
					justifyContent: "space-between",
					padding: 1,
					borderRadius: 1,
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						flex: 1,
					}}
				>
					<Typography
						sx={{
							fontSize: 12,
							color: Colours.gsblue,
							ml: 2,
							userSelect: "none",
						}}
					>
					{barcode?.barcode && barcode?.barcode}
					</Typography>
				</Box>
			</Box>
			{checkPermissions(userPermission, {
				page: "items",
				strict: false,
				action: "edit",
			}) === true && (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: 55,
					}}
				>
					<Close
						style={{
							color: Colours.gsblue,
							padding: 0,
							fontSize: "medium",
						}}
						onClick={() => removeItem(barcode?.id)}
					/>
				</Box>
			)}
		</Box>
	);
};
